const beforValueAction = {
  props: {
    //值为{type: "mutations/actions", name:"定义是动作名称", extendData: "额外参数", dataIndex:"在表格时可使用，表示当前行的下标"}
    beforValueAction: {
      type: Object,
      default: null,
    },
  },
  methods: {
    async beforeEmit(val) {
      let flag = true
      if (this.beforValueAction && this.beforValueAction.type == 'mutations' && this.store) {
        this.store.commit(
          this.beforValueAction.name,
          val,
          this.beforValueAction.dataIndex,
          this.beforValueAction.extendData
        )
      } else if (this.beforValueAction && this.beforValueAction.type == 'actions' && this.store) {
        flag = await this.store.dispatch(
          this.beforValueAction.name,
          val,
          this.beforValueAction.dataIndex,
          this.beforValueAction.extendData
        )
      }
      if (flag?.type) {
        this.$emit('input', flag?.val)
      } else if (flag) this.$emit('input', val)

      return flag
    },
    //带校验
    async emitValueValidate(val) {
      const res = await this.beforeEmit(val)
      if (res && this.dispatch) {
        this.dispatch('FormItem', 'on-form-blur', val)
        this.dispatch('FormItem', 'on-form-change', val)
      }
      return res
    },
  },
}

export { beforValueAction }
